import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CommonFlex, PageTitle } from '../../styledComponents/common';
import { ButtonIcon, WhiteButtonWithIcon } from 'styledComponents/buttons';
import ButtonTextLoader from 'components/Loaders/ButtonTextLoader';
import excelIcon from '../../assets/img/icons/excel-green.svg';
import ItemsTransactionsReportFilterContainer from './Filter/ItemsTransactionsReportFilterContainer';
import ItemsTransactionsReportList from './ItemsTransactionsReportList';

const ItemsTransactionsReport = ({
  itemsTransactionsList = [],
  isLoading,
  reportLoading,
  sendExportExcelRequest,
}) => {
  const { t } = useTranslation();
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [selectedParams, setSelectedParams] = useState({});

  const handleExportToExcel = () => {
    sendExportExcelRequest(selectedParams, 'transaction-sub-tasks');
  };

  return (
    <div className="content">
      <CommonFlex alignItem="center" justify="space-between">
        <PageTitle>{t('items_transactions_report')}</PageTitle>
        <CommonFlex gap="12px">
          {localStorage.getItem('user_role') !== 'employee' ? (
            <WhiteButtonWithIcon
              onClick={() => handleExportToExcel()}
              color="#19AC65"
              borderColor="#19AC65"
              hoverBorderColor="#129652"
              padding={reportLoading ? '0 45px' : '0 25px'}
            >
              {reportLoading ? (
                <ButtonTextLoader color="#19AC65" loadingText=" " size={6} />
              ) : (
                <>
                  <ButtonIcon src={excelIcon} size="26px" />
                  {t('export_report')}
                </>
              )}
            </WhiteButtonWithIcon>
          ) : null}
        </CommonFlex>
      </CommonFlex>
      <ItemsTransactionsReportFilterContainer
        setSelectedParams={setSelectedParams}
        selectedParams={selectedParams}
      />
      <ItemsTransactionsReportList
        isLoading={isLoading}
        itemsTransactionsList={itemsTransactionsList}
        selectedTransaction={selectedTransaction}
        selectTransaction={setSelectedTransaction}
      />
    </div>
  );
};

export default ItemsTransactionsReport;
